import { toUTCDateOnly } from "@common/helpers/date";
import { BillStatus } from "@common/types/bill";

export enum BillScheduleBlockReason {
    draft = "draft",
    void = "void",
    nonUsd = "nonUsd",
}

const STATUS_BLOCK_REASONS: Record<BillStatus, BillScheduleBlockReason | null> =
    {
        [BillStatus.OPEN]: null,
        [BillStatus.PAID]: null,
        [BillStatus.DRAFT]: BillScheduleBlockReason.draft,
        [BillStatus.VOID]: BillScheduleBlockReason.void,
    };

export const BILL_SCHEDULE_BLOCK_MESSAGES: Record<
    BillScheduleBlockReason,
    string
> = {
    [BillScheduleBlockReason.draft]:
        "Schedules can't be applied to draft bills",
    [BillScheduleBlockReason.void]: "Schedules can't be applied to void bills",
    [BillScheduleBlockReason.nonUsd]: "Only posted USD bills can be scheduled",
};

export function getBillScheduleBlockReason(bill: {
    status: BillStatus;
    currency: string;
}): BillScheduleBlockReason | null {
    const statusReason = STATUS_BLOCK_REASONS[bill.status];
    if (statusReason) {
        return statusReason;
    }
    if (bill.currency.toLowerCase() !== "usd") {
        return BillScheduleBlockReason.nonUsd;
    }
    return null;
}

export const BILL_SCHEDULE_LINE_MISMATCH_MESSAGE =
    "Selected bill lines do not belong to the bill";

export function getBillScheduleBlockMessage(bill: {
    status: BillStatus;
    currency: string;
}): string | null {
    const blockReason = getBillScheduleBlockReason(bill);
    return blockReason ? BILL_SCHEDULE_BLOCK_MESSAGES[blockReason] : null;
}

/**
 * The calendar day a schedule on a bill runs from: the bill date, or for
 * bills that carry none, the UTC day it was created, the day its journal
 * entries post on.
 */
export function resolveBillSourceDate(bill: {
    dateOnly: string | null;
    createdAt: Date | string;
}): string {
    return bill.dateOnly ?? toUTCDateOnly(bill.createdAt);
}
